import React from "react";

const icons = { fertilizer: "💧", fresh_water: "🚿" };

export default function OutputCard({ output }) {
  return (
    <div className="output-card">
      <span className="output-icon">{icons[output.type] || "⚡"}</span>
      <span className="output-label">{output.label}</span>
      <span className="output-status">Available</span>
    </div>
  );
}
